const UPPERCASE = 'ABCDEFGHJKLMNPQRSTUVWXYZ';
const LOWERCASE = 'abcdefghjkmnpqrstuvwxyz';
const DIGITS = '23456789';
const SPECIAL = '!@#$%&*+-=?';

/** Генерирует пароль: от 8 символов, минимум 1 спецсимвол, 1 цифра, 1 большая буква */
export function generatePassword(length: number = 12): string {
  const parts = [
    UPPERCASE[Math.floor(Math.random() * UPPERCASE.length)],
    DIGITS[Math.floor(Math.random() * DIGITS.length)],
    SPECIAL[Math.floor(Math.random() * SPECIAL.length)],
  ];
  const all = UPPERCASE + LOWERCASE + DIGITS + SPECIAL;
  for (let i = parts.length; i < length; i++) {
    parts.push(all[Math.floor(Math.random() * all.length)]);
  }
  return parts.sort(() => Math.random() - 0.5).join('');
}

export type PasswordValidation = { valid: boolean; messageKey?: string };

export function validatePassword(password: string): PasswordValidation {
  if (password.length < 8) {
    return { valid: false, messageKey: 'validation.password.minLength' };
  }
  if (!/[A-Z]/.test(password)) {
    return { valid: false, messageKey: 'validation.password.uppercase' };
  }
  if (!/[0-9]/.test(password)) {
    return { valid: false, messageKey: 'validation.password.digit' };
  }
  if (!/[!@#$%&*+\-=?]/.test(password)) {
    return { valid: false, messageKey: 'validation.password.special' };
  }
  return { valid: true };
}
